export default __webpack_public_path__ + "static/media/temple-rakshak.9f1b8e28.jpg";